import axios, { AxiosError } from 'axios';
import axiosRetry from 'axios-retry';
import * as Sentry from '@sentry/react';

import config from '../../config';
import { history } from '../store';

export const api = axios.create({
  baseURL: config.app.url + '/api/v1',
});
axiosRetry(api, {
  retries: 3, // number of retries
  retryDelay: (retryCount: number) => {
    return retryCount * 1000; // time interval between retries
  },
  retryCondition: (error: any) => {
    // if retry condition is not specified, by default idempotent requests are retried
    return error.response ? error.response.status === 502 : false;
  },
});
export const configureSecurityInterceptorWithTokens = async ({
  accessToken, csrfToken
}: {
  accessToken: string;
  csrfToken: string;
}): Promise<void> => {
  api.interceptors.request.use(async config => {
    const requestConfig = config;
    if (accessToken) {
      requestConfig.headers.common.Authorization = `Bearer ${accessToken}`;
    }

    return requestConfig;
  });
};
export const configureDefaultErrorInterceptor = async (
): Promise<void> => {
  api.interceptors.response.use(function (response) {
    return response;
  }, async function (error) {
    // const originalRequest = error.config;
    if (error.response.status === 401) {
      window.location.href = config.app.url + '/logout?referrer=' + (history.location?.pathname || '');
      return Promise.reject(error);
    } else if (error.response.status === 404) {
      history.push('/a/notfound', { from: history.location });
      return ;
    } else if (error.response.status === 422) {
      return Promise.reject(error);
    } else if (error.response.status === 500) {
      return Promise.reject(error);
    }
    if (error?.response?.status === 502) {
      Sentry.captureException(new Error(JSON.stringify(error)), {
        tags: {
          section: 'Error 502 Bad Gateway',
        },
      });
    }
    return Promise.reject(error);
  });
};
